import React from 'react';
import { ShippingMethodContract } from '../../../types/ShippingMethods';
import Reload from '../../content/Reload';
import ShippingMethodList from '../ShippingMethodList';

export const ShippingMethodIsLoadingTestId =
  'IsLoading-ShippingMethodForm-input';
export const ShippingMethodNotCalculatedTestId =
  'NotCalculated-ShippingMethodForm-input';

export type ShippingMethodFormProps = {
  isLoading: boolean;
  isRefetching?: boolean;
  formattedCurrencySymbol: string;
  shippingMethods: ShippingMethodContract[];
  selectedShippingMethod?: ShippingMethodContract | null;
  onShippingMethodChanged: (selectedShippingMethodId: number) => void;
};

const ShippingMethodForm: React.FC<ShippingMethodFormProps> = ({
  isLoading,
  isRefetching = false,
  shippingMethods,
  formattedCurrencySymbol,
  onShippingMethodChanged,
  selectedShippingMethod,
}: ShippingMethodFormProps) => {
  if (isLoading) {
    return (
      <div className="p-2 mb-6" data-testid={ShippingMethodIsLoadingTestId}>
        Calculating shipping methods...
        <Reload />
      </div>
    );
  }
  if (isRefetching || !shippingMethods?.length) {
    return (
      <div data-testid={ShippingMethodNotCalculatedTestId} className="p-2 mb-6">
        Calculated after you enter shipping address above.
      </div>
    );
  }
  return (
    <ShippingMethodList
      shippingMethods={shippingMethods}
      formattedCurrencySymbol={formattedCurrencySymbol}
      onShippingMethodChanged={onShippingMethodChanged}
      selectedShippingMethod={selectedShippingMethod}
    />
  );
};
export default ShippingMethodForm;
